import React from "react";
import "./ExistingDiscrepancyModal.scss";
import { NewDiscrepancyModal } from "../NewDiscrepancyModal/NewDiscrepancyModal";
import { TextAreaComponent } from "../../../../../components/TextArea/TextAreaComponent";
export const ExistingDiscrepancyModal = ({ onClose }) => {
  const handleClose = () => {
    onClose();
  };
  return (
    <section className="ExistingDiscrepancyModal">
      <nav>
        <div>
          <span class="icon-coloredwarning">
            <span class="path1"></span>
            <span class="path2"></span>
          </span>
        </div>
        <h3>Discrepancy</h3>
        <button className="outlined icon small-size" onClick={handleClose}>
          <i className="icon-cross"></i>
        </button>
      </nav>
      <section>
        <div>
          <NewDiscrepancyModal
            disabled={true}
            styles={{
              width: "100%",
              height: "100%",
              justifyContent: "space-around",
              padding: "0",
            }}
            isNewDiscrepancy={false}
          ></NewDiscrepancyModal>
        </div>
        <div>
          <div className="ExistingDiscrepancyModal-disc-resolution-cont">
            <div>
              <p>Discrepancy Resolution</p>
              <button>
                <i className="icon-chat"></i> Supply Chain
              </button>
            </div>
            <div className="ExistingDiscrepancyModal-disc-resolution-msg">
              <div style={{ flexGrow: "1", width: "100%" }}>
                <TextAreaComponent value={"lorem ipsum..."}></TextAreaComponent>
              </div>
              <button className="ExistingDiscrepancyModal-confirm-btn">
                Confirm Resolution
              </button>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};
